export const WEB_STORAGE_KEYS = {
    auth: 'auth',
    auth_v3: 'auth_v3',
    auth_v4: 'auth_v4',
    language: 'locale',
    installer: 'installer',
    order_id: 'order_id',
    installer_match: 'installer_match',
    site_id: 'current_site_id',
    installerCount: 'installer_count',
    enlighten_admin: 'enlighten_ISR',
    calculate: 'calculate',
    feedBack: 'feedBack',
    bomList: 'bomList',
    contactInfo: 'contactInfo'
};

export const REG_PATTERN = {
    phone: /^\d{10}$/,
    email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, /* a.b@abc.abc */
    usPhone: /^\d{10}$|^\d{3}-\d{3}-\d{4}$/,
    dePhone: /^((?:\s?(?:\()?\d(?:\))?){6,16})$/,
    auPhone: /^\d{9}$/,
    zip: /^\d{6}$|^\d{5}$|^\d{5}-\d{4}$/,
    name: /^([a-zA-Z]+ *)+$/,
    fullName: /^[a-zA-Z.-]+ +([a-zA-Z.-]+ *)+$/,
    amount: /^(\d{1,5})$/,
    year: /^(19|20)\d{2}$/,
    germanFullName: /^[a-zA-ZäöüÄÖÜß.-]+ +([a-zA-ZäöüÄÖÜß.-]+ *)+$/,
    indianZip: /^\d{6}$/,
    'es-es': {
        phone: /^\d{9}$/,
        name: /^([a-zA-ZáéíóúâêôãõçÁÉÍÓÚÂÊÔÃÕÇüñÜÑ]+ *)+$/,
    },
    germanzip: /^\d{6}$|^\d{5}$|^\d{4}$|^\d{5}-\d{4}$/
};

export const moneySymbol = {
    usd: '$',
    cad: '$',
    gbp: '£',
    eur: '€',
    brl: 'R$',
    pln: 'zł',
    chf: 'CHF',
    aud: 'A$',
    nzd: 'NZ$',
    czk: 'Kč',
    huf: 'Ft',
    inr: '₹',
    jpy: '¥',
    dkk: 'kr.',
    sek: 'kr',
    zar: 'R',
    thb: '฿',
    nok: 'kr',
    php: '₱',
    mxn: 'MX$'
};

export const countryToCurrencyCodeMap: { [key: string]: string } = {
    US: 'USD',
    CA: 'CAD',
    GB: 'GBP',
    AU: 'AUD',
    NZ: 'NZD',
    BR: 'BRL',
    PL: 'PLN',
    CH: 'CHF',
    CZ: 'CZK',
    HU: 'HUF',
    IN: 'INR',
    JP: 'JPY',
    DK: 'DKK',
    SE: 'SEK',
    ZA: 'ZAR',
    TH: 'THB',
    NO: 'NOK',
    PH: 'PHP',
    MX: 'MXN',
    NL: 'EUR',
    DE: 'EUR',
    IT: 'EUR',
    ES: 'EUR'
};

export const countryPhoneExtensionMap: { [key: string]: string } = {
    US: '1',
    AU: '61',
    DE: '49',
    ES: '34',
    FR: '33',
    IT: '39',
    NL: '31',
    BE: '32',
    MX: '52',
    IN: '91',
    PR: '1'
};

export type LegalLinks = {
    terms: string;
    privacy: string;
    contact: string;
    accessibility: string;
};

export const DEFAULT_LEGAL_LINKS: LegalLinks = {
    terms: 'https://enphase.com/legal/terms-of-service',
    privacy: 'https://enphase.com/legal/privacy-policy',
    contact: 'https://enphase.com/contact',
    accessibility: 'https://enphase.com/legal/accessibility-statement',
};

export const LEGAL_LINKS_BY_COUNTRY: { [key: string]: LegalLinks } = {
    NL: {
        terms: 'https://enphase.com/nl-nl/legal/terms-service',
        privacy: 'https://enphase.com/nl-nl/legal/privacy-policy',
        contact: 'https://enphase.com/nl-nl/contact-us',
        accessibility: 'https://enphase.com/nl-nl/legal/accessibility-statement',
    },
    US: DEFAULT_LEGAL_LINKS,
};

export const CONS_PROFILE_LIST = [
    { key: 'Default residential', title: 'Default residential', value: 'defaultResidential' },
    { key: 'Household with school kids', title: 'Household with school kids', value: 'householdWithSchoolKids' },
    { key: 'Household with infants', title: 'Household with infants', value: 'householdWithInfants' },
    { key: 'Single or two person household', title: 'Single or two person household', value: 'singleOrTwoPerson' },
    { key: 'Work from home couple', title: 'Work from home couple', value: 'workFromHomeCouple' },
    { key: 'Retirees or stay at home couple', title: 'Retirees or stay at home couple', value: 'retireesOrWorking' },
    { key: 'Nighttime focused', title: 'Nighttime focused', value: 'nightTimeFocussed' },
    // { key: 'Family with kids', title: 'Family with kids', value: 0 },
    // { key: '2-person household', title: '2-person household', value: 2 },
    // { key: '1-person household', title: '1-person household', value: 1 },
    [{ key: 'Mornings (6 AM - 10 AM)', title: 'Mornings' },
    { key: 'Afternoons (10 AM - 4 PM)', title: 'Afternoons' },
    { key: 'Evenings (4 PM - 9 PM)', title: 'Evenings' },
    { key: 'Nights (9 PM - 6 AM)', title: 'Nights' }],
];
export const CONS_PROFILE_LIST_V4 = [
    { key: 'Default residential', title: 'Default residential', value: 'defaultResidential' },
    { key: 'Household with school kids', title: 'Household with school kids', value: 'householdWithSchoolKids' },
    { key: 'Household with infants', title: 'Household with infants', value: 'householdWithInfants' },
    { key: 'Single or two person household', title: 'Single or two person household', value: 'singleOrTwoPerson' },
    { key: 'Work from home couple', title: 'Work from home couple', value: 'workFromHomeCouple' },
    { key: 'Retirees or stay at home couple', title: 'Retirees or stay at home couple', value: 'retireesOrWorking' },
    { key: 'Nighttime focused', title: 'Nighttime focused', value: 'nightTimeFocussed' }
];
export const MODE = { fullBackup: 0, energyIndependence: 1, savings: 2 };
export const BACKUP_MODES =
    [
        { key: 'Energy Independence', value: 1, title: 'Be more grid independent.', description: `Self-power more than 85% of your consumption.` },
        { key: 'Backup during Outages', value: 0, title: 'Get respite from grid outages.', description: `Backup your home during outages.` },
        { key: 'Savings on Monthly Electricity Bill', value: 2, title: 'Maximize your electricity bill savings.', description: `Maximize your savings and get backup for 6 hours during outages.` }
    ];
export const MICRO_LIST_VAL =
    [
        { label: 'IQ8HC', value: 380, peak: 0.384, continuous_output_current:1.58, part_number: 'IQ8HC-240-72-M-US', max_micro_per_branch: 10},
        { label: 'IQ8', value: 240, peak: 0.250, continuous_output_current:1, part_number: 'IQ8-60-2-US', max_micro_per_branch: 16 },
        { label: 'IQ8+', value: 290, peak: 0.300, continuous_output_current:1.21, part_number: 'IQ8PLUS-72-2-US', max_micro_per_branch: 13 },
        // { label: 'IQ8PLUS', value: 290, peak: 0.300, continuous_output_current:1.21, part_number: 'IQ8PLUS-72-2-US', max_micro_per_branch: 13 },
        { label: 'IQ8A', value: 349, peak: 0.366, continuous_output_current:1.45, part_number: 'IQ8A-72-2-US', max_micro_per_branch: 11 },
        { label: 'IQ8MC', value: 320, peak: 0.330, continuous_output_current:1.33, part_number: 'IQ8MC-240-72-M-US', max_micro_per_branch: 12 },
        { label: 'IQ7+', value: 290, peak: 0.295, part_number: 'IQ7PLUS-Q-12-20-1', max_micro_per_branch: 13 },
        { label: 'IQ7X', value: 315, peak: 0.320, part_number: 'IQ7X-Q-12-20-1', max_micro_per_branch: 12 },
        { label: 'IQ7A', value: 349, peak: 0.366, part_number: 'IQ7A-Q-12-20-1', max_micro_per_branch: 11 },
        { label: 'IQ7', value: 240, peak: 0.250, part_number: 'IQ7-Q-12-17-1', max_micro_per_branch: 16 },
        { label: 'IQ6+', value: 280, peak: 0.290, part_number: 'IQ6PLUS-72-2-US', max_micro_per_branch: 13 },
        { label: 'IQ6', value: 230, peak: 0.240, part_number: 'IQ6-60-2-US', max_micro_per_branch: 16 }
    ];
export const MICRO_LIST = MICRO_LIST_VAL.slice(0, -6);
export const NEW_USER_MICRO_LIST = MICRO_LIST_VAL.slice(0, -2);

// export const EXISTING_USER_MICRO_LIST =
//     [
//         { label: 'IQ8+', value: 290, peak: 0.300, part_number: 'IQ8PLUS-72-2-US', max_micro_per_branch: 11 },
//         { label: 'IQ8', value: 240, peak: 0.250, part_number: 'IQ8-60-2-US', max_micro_per_branch: 11 }
//     ];
export const APPLIANCE_LIMITS = {
    operatingPower: {
        Watts: { min: 1, max: 30000 },
        Ton: { min: 0.5, max: 30 },
        Amps: { min: 0.1, max: 125 },
        hp: { min: 0.5, max: 25 }
    },
    surgePower: {
        Watts: { min: 1, max: 45000 },
        Ton: { min: 0.5, max: 35 },
        Amps: { min: 0.1, max: 187 },
        hp: { min: 0.5, max: 40 },
        factor: { min: 1, max: 10 }
    },
    activeHours: { min: 0.1, max: 24 },
    qty: { min: 0, max: 100 },
    consumption: {
        Day: { min: 10, max: 150 },
        Month: { min: 300, max: 4500 },
        Year: { min: 4, max: 54 }
    }
};

export const NL_ENERGY_CONTRACT_DEFAULT_RATES: {
    [key: string]: { importRate: number | null; feedInTariffRate: number | null }
} = {
    net: { importRate: 0.3, feedInTariffRate: 0.15 },
    netFit: { importRate: 0.3, feedInTariffRate: 0.05 },
    fit: { importRate: 0.3, feedInTariffRate: 0.05 },
    dynamic: { importRate: 0.35, feedInTariffRate: 0.08 }
};

export const APPLIANCE_LIMITS_DE = {
    operatingPower: {
        Watts: { min: 1, max: 30000 },
        Ton: { min: 0.5, max: 30 },
        Amps: { min: 0.1, max: 125 },
        hp: { min: 0.5, max: 25 }
    },
    surgePower: {
        Watts: { min: 1, max: 45000 },
        Ton: { min: 0.5, max: 35 },
        Amps: { min: 0.1, max: 187 },
        hp: { min: 0.5, max: 40 },
        factor: { min: 1, max: 10 }
    },
    activeHours: { min: 0.1, max: 24 },
    qty: { min: 0, max: 100 },
    consumption: {
        Day: { min: 1, max: 110 },
        Month: { min: 30, max: 3300 },
        Year: { min: 360, max: 40000 }
    }
};
export const APPLIANCE_DESCRIPTION = {
    'Large Appliances': 'High consumption, Regular-use',
    'Essential Appliances': 'Low consumption, Daily-use',
    'Heavy Appliances': 'Very high consumption, backup not recommended​​',
    'Additional Appliances': 'Appliances you added'
};
export const MICRO_UPGRADE_MAP = {
    M175: { new: 'IQ7-PD-72', replaceUnits: 1, sum: 0 },
    M190: { new: 'IQ7-PD-72', replaceUnits: 1, sum: 0 },
    M210: { new: 'IQ7-PD-84', replaceUnits: 1, sum: 0 },
    M215: { new: 'IQ7', replaceUnits: 1, sum: 0 },
    M250: { new: 'IQ7+', replaceUnits: 1, sum: 0 },
    D380: { new: 'IQ7-PD-72', replaceUnits: 2, sum: 0 },
    other: { new: 'IQ7', replaceUnits: 1, sum: 0 }
};
export const BILL_FACTORS =
    [
        { s: ['connecticut', 'ct'], f: .2895, bi: 1, ao: 156 },
        { s: ['maine', 'me'], f: .2913, bi: 1.9, ao: 143 },
        { s: ['massachusetts', 'ma'], f: .2802, bi: 1.7, ao: 156 },
        { s: ['new hampshire', 'nh'], f: .2576, bi: 1.4, ao: 116 },
        { s: ['rhode island', 'ri'], f: .3178, bi: 1.7, ao: 89 },
        { s: ['vermont', 'vt'], f: .2211, bi: 1.3, ao: 122 },
        { s: ['new jersey', 'nj'], f: .1751, bi: -.5, ao: 116 },
        { s: ['new york', 'ny'], f: .227, bi: -1.3, ao: 141 },
        { s: ['pennsylvania', 'pa'], f: .1843, bi: -1, ao: 135 },
        { s: ['illinois', 'il'], f: .1583, bi: .3, ao: 103 },
        { s: ['indiana', 'in'], f: .1517, bi: 2, ao: 106 },
        { s: ['michigan', 'mi'], f: .1906, bi: 1.4, ao: 194 },
        { s: ['ohio', 'oh'], f: .1601, bi: -.8, ao: 119 },
        { s: ['wisconsin', 'wi'], f: .1705, bi: -.1, ao: 66 },
        { s: ['iowa', 'ia'], f: .1337, bi: 1.7, ao: 49 },
        { s: ['kansas', 'ks'], f: .1372, bi: .2, ao: 64 },
        { s: ['minnesota', 'mn'], f: .1529, bi: 1.6, ao: 82 },
        { s: ['missouri', 'mo'], f: .1242, bi: .5, ao: 85 },
        { s: ['nebraska', 'ne'], f: .1176, bi: .4, ao: 66 },
        { s: ['north dakota', 'nd'], f: .1166, bi: .2, ao: 45 },
        { s: ['south dakota', 'sd'], f: .1299, bi: 1, ao: 69 },
        { s: ['delaware', 'de'], f: .1746, bi: -1.2, ao: 91 },
        { s: ['district of columbia', 'dc'], f: .1802, bi: .3, ao: 117 },
        { s: ['florida', 'fl'], f: .1736, bi: -.1, ao: 173 },
        { s: ['georgia', 'ga'], f: .1375, bi: .5, ao: 126 },
        { s: ['maryland', 'md'], f: .184, bi: -1.4, ao: 107 },
        { s: ['north carolina', 'nc'], f: .1475, bi: .2, ao: 174 },
        { s: ['south carolina', 'sc'], f: .1447, bi: .9, ao: 120 },
        { s: ['virginia', 'va'], f: .1427, bi: .4, ao: 129 },
        { s: ['west virginia', 'wv'], f: .1507, bi: 0.9, ao: 150 },
        { s: ['alabama', 'al'], f: .1502, bi: 1, ao: 110 },
        { s: ['kentucky', 'ky'], f: .1299, bi: 1.1, ao: 83 },
        { s: ['mississippi', 'ms'], f: .1367, bi: -.5, ao: 120 },
        { s: ['tennessee', 'tn'], f: .1257, bi: .8, ao: 61 },
        { s: ['arkansas', 'ar'], f: .1271, bi: .1, ao: 92 },
        { s: ['louisiana', 'la'], f: .1192, bi: .2, ao: 115 },
        { s: ['oklahoma', 'ok'], f: .1327, bi: -.1, ao: 69 },
        { s: ['texas', 'tx'], f: .1471, bi: -.2, ao: 128 },
        { s: ['arizona', 'az'], f: .1452, bi: .3, ao: 134 },
        { s: ['colorado', 'co'], f: .1454, bi: .5, ao: 81 },
        { s: ['idaho', 'id'], f: .1215, bi: -.5, ao: 46 },
        { s: ['montana', 'mt'], f: .1296, bi: .3, ao: 39 },
        { s: ['nevada', 'nv'], f: .1463, bi: -1.5, ao: 65 },
        { s: ['new mexico', 'nm'], f: .145, bi: -1.3, ao: 44 },
        { s: ['utah', 'ut'], f: .1122, bi: -.7, ao: 73 },
        { s: ['wyoming', 'wy'], f: .1247, bi: .3, ao: 32 },
        { s: ['california', 'ca'], f: .39, bi: 1.8, ao: 199 },
        { s: ['oregon', 'or'], f: .1324, bi: .1, ao: 99 },
        { s: ['washington', 'wa'], f: .1134, bi: 1.7, ao: 104 },
        { s: ['alaska', 'ak'], f: .2398, bi: 2.8, ao: 50 },
        { s: ['hawaii', 'hi'], f: .4269, bi: 1.9, ao: 119 }
    ];
export const LOAD_FACTOR_MAP = {
    'hp': [
        { load: 0.5, factor: 2.352 },
        { load: 0.75, factor: 2.208 },
        { load: 1, factor: 1.92 },
        { load: 1.5, factor: 1.6 },
        { load: 2, factor: 1.44 },
        { load: 3, factor: 1.36 },
        { load: 5, factor: 1.344 },
        { load: 15, factor: 1.28 }
    ],
    'ton': [
        { load: 1.5, factor: 1.52 },
        { load: 2, factor: 1.44 },
        { load: 3, factor: 1.16 },
        { load: 4, factor: 1.05 },
        { load: 5, factor: 1.152 },
        { load: 16, factor: 1.02 }
    ],
    defaults: {
        'hp': 1.28,
        'ton': 1.02,
        'amps': 0.24
    }
};
export const HOME_SIZE_CONS = [ /* consumption based on pure home size */
    { slab: 1, minSqft: 500, maxSqft: 1200, baseConsumption: 15, addOnConsPerSqft: 0.01428 },
    { slab: 2, minSqft: 1200, maxSqft: 3400, baseConsumption: 25, addOnConsPerSqft: 0.00454 },
    { slab: 3, minSqft: 3400, maxSqft: 6000, baseConsumption: 35, addOnConsPerSqft: 0.01115 }
];

export const GRAPHS = {
    savings: 'eBillGraph',
    cashFlow: 'cashFlowGraph',
    billPayments: 'billPaymentGraph',
    electricity: 'electricityGraph'
}

export const FORM_2S_METER_PAN = 'Form 2S Meter Pan';

export const BatteryTypes = {
    enc10c: 'enc10CBattery',
    enc5p: 'enc5PBattery'
}

export const STATIC_STOR_CONFIGS_10C = [
    { uuid: '3c3030dc-86b9-4e75-951e-3dc85a886e38', price: 12500, storOpPower: 7.08, storSurgePower: 14.16, totalCapacity: 10.0, stepSize: 10 },
    { uuid: '23ccd7df-f485-4ff5-b893-05a99c24b7e4', price: 25000, storOpPower: 14.16, storSurgePower: 28.32, totalCapacity: 20.0, stepSize: 10 },
    { uuid: 'd2e6fb4a-a078-4856-9525-78faba2384dc', price: 37500, storOpPower: 21.24, storSurgePower: 42.48, totalCapacity: 30.0, stepSize: 10 },
    { uuid: 'da3c6ce7-711a-47f8-8fd1-db00b1f9d159', price: 50000, storOpPower: 28.32, storSurgePower: 56.64, totalCapacity: 40.0, stepSize: 10 }
];

export const STATIC_SOLAR_ONLY_STOR_CONFIGS_10C = [
  { uuid: "02ac2d80-c341-4c81-9851-c61d29af5701", price: 12500, storOpPower: 7.08, storSurgePower: 14.16, totalCapacity: 0, stepSize: 10 },
  { uuid: "02ac2480-c341-4c81-9851-c61d29af5702", price: 25000, storOpPower: 14.16, storSurgePower: 28.32, totalCapacity: 0, stepSize: 10 },
  { uuid: "04ac2480-c341-4c81-9851-c61d29af5701", price: 50000, storOpPower: 21.24, storSurgePower: 42.48, totalCapacity: 0, stepSize: 10 },
  { uuid: "04ac2480-c341-4c81-9851-c61d29af5702", price: 37500, storOpPower: 28.32, storSurgePower: 56.64, totalCapacity: 0, stepSize: 10 }
];
    
export const STATIC_STOR_CONFIGS_5P = [
  { uuid: 'e8b7b0f5-b5d9-4b46-ac0e-2853ce2efb6e', price: 7000, storOpPower: 3.84, storSurgePower: 7.68, totalCapacity: 5.0, stepSize: 5 },
  { uuid: '3cdd3cc1-6d02-4a87-b6c6-0fb17254d396', price: 14000, storOpPower: 7.68, storSurgePower: 15.36, totalCapacity: 10.0, stepSize: 5 },
  { uuid: 'a84a7a2c-7f55-4f8b-92ca-4ef9d87842fb', price: 21000, storOpPower: 11.52, storSurgePower: 23.04, totalCapacity: 15.0, stepSize: 5 },
  { uuid: 'b6e1d385-6217-4b6c-93e9-c04bcb49a52d', price: 28000, storOpPower: 15.36, storSurgePower: 30.72, totalCapacity: 20.0, stepSize: 5 },
  { uuid: '02c5f2b7-c0cc-4f21-8f82-3fb31d460111', price: 35000, storOpPower: 19.2, storSurgePower: 38.4, totalCapacity: 25.0, stepSize: 5 },
  { uuid: '77d3fd17-9b18-4a6c-992e-2bf0cfcf0d44', price: 42000, storOpPower: 23.04, storSurgePower: 46.08, totalCapacity: 30.0, stepSize: 5 },
  { uuid: '873bf48d-576f-48ca-a02f-13cfd56841a3', price: 49000, storOpPower: 26.88, storSurgePower: 53.76, totalCapacity: 35.0, stepSize: 5 },
  { uuid: '7d979c23-13cf-4df3-bd64-76b572e82ba3', price: 56000, storOpPower: 30.72, storSurgePower: 61.44, totalCapacity: 40.0, stepSize: 5 }
];

export const STATIC_SOLAR_ONLY_STOR_CONFIGS_5P = [
  { uuid: 'd1f1f6cc-6c3e-47a3-9a3b-eac28b778e11', price: 7000, storOpPower: 3.84, storSurgePower: 7.68, totalCapacity: 0, stepSize: 5 },
  { uuid: 'c82221a2-2d16-4b78-9d38-1bc6dbf7e3a7', price: 14000, storOpPower: 7.68, storSurgePower: 15.36, totalCapacity: 0, stepSize: 5 },
  { uuid: '3ede99d0-5dc1-4c80-9f38-18a433eae275', price: 21000, storOpPower: 11.52, storSurgePower: 23.04, totalCapacity: 0, stepSize: 5 },
  { uuid: 'fd614b45-aad3-4cc1-8bb0-a7e21d081774', price: 28000, storOpPower: 15.36, storSurgePower: 30.72, totalCapacity: 0, stepSize: 5 },
  { uuid: '0c142111-561a-4b71-a62e-224f019e37be', price: 35000, storOpPower: 19.2, storSurgePower: 38.4, totalCapacity: 0, stepSize: 5 },
  { uuid: 'f9a3f74f-9a21-49e6-9f6d-58051cac4e3b', price: 42000, storOpPower: 23.04, storSurgePower: 46.08, totalCapacity: 0, stepSize: 5 },
  { uuid: 'b2af5f33-e606-49ef-8a54-fe6b6222247e', price: 49000, storOpPower: 26.88, storSurgePower: 53.76, totalCapacity: 0, stepSize: 5 },
  { uuid: '52da923a-21fe-4b1e-acd6-b95a849fb376', price: 56000, storOpPower: 30.72, storSurgePower: 61.44, totalCapacity: 0, stepSize: 5 }
];

export const NL_IQ_BATTERY_5P_PRICE_TABLE = [
  { configurationKey: 'sat.v4.nl_iq_battery_5p_config_1', price: 4700 },
  { configurationKey: 'sat.v4.nl_iq_battery_5p_config_2', price: 7600 },
  { configurationKey: 'sat.v4.nl_iq_battery_5p_config_3', price: 10400 },
  { configurationKey: 'sat.v4.nl_iq_battery_5p_config_4', price: 13100 },
  { configurationKey: 'sat.v4.nl_iq_battery_5p_config_5', price: 15800 },
  { configurationKey: 'sat.v4.nl_iq_battery_5p_config_6', price: 18500 },
  { configurationKey: 'sat.v4.nl_iq_battery_5p_config_7', price: 21000 },
  { configurationKey: 'sat.v4.nl_iq_battery_5p_config_8', price: 23700 },
];

export const NL_IQ_BATTERY_5P_WITH_BACKUP_PRICE_TABLE = [
  { configurationKey: 'sat.v4.nl_iq_battery_5p_with_backup_config_1', price: 7700 },
  { configurationKey: 'sat.v4.nl_iq_battery_5p_with_backup_config_2', price: 10600 },
  { configurationKey: 'sat.v4.nl_iq_battery_5p_with_backup_config_3', price: 13400 },
  { configurationKey: 'sat.v4.nl_iq_battery_5p_with_backup_config_4', price: 16100 },
  { configurationKey: 'sat.v4.nl_iq_battery_5p_with_backup_config_5', price: 18800 },
  { configurationKey: 'sat.v4.nl_iq_battery_5p_with_backup_config_6', price: 21500 },
  { configurationKey: 'sat.v4.nl_iq_battery_5p_with_backup_config_7', price: 24000 },
  { configurationKey: 'sat.v4.nl_iq_battery_5p_with_backup_config_8', price: 26700 },
];

export const BATTERY_DIMENSIONS_DETAILS_10C = {
    "10": { weight: 357, height: 26.8, width: 50.1 },
    "20": { weight: 674, height: 26.8, width: 82.1 },
    "30": { weight: 991, height: 26.8, width: 114.1 },
    "40": { weight: 1308, height: 55, width: 82.1 },
}

export const BATTERY_DIMENSIONS_DETAILS_5P = {
    "5": { weight: 277.5, height: 38.6, width: 66.9 },
    "10": { weight: 451.5, height: 38.6, width: 91.6 },
    "15": { weight: 625.5, height: 38.6, width: 116.3 },
    "20": { weight: 799.5, height: 38.6, width: 141 },
    "25": { weight: 973.5, height: 85.2, width: 116.3 },
    "30": { weight: 1147.5, height: 85.2, width: 116.3 },
    "35": { weight: 1321.5, height: 85.2, width: 141 },
    "40": { weight: 1495.5, height: 85.2, width: 141 },
}

export const TIMEZONES = [
  {
    codes: 'EDT_EST',
    daylightName: 'Eastern Daylight Time',
    daylightOffset: -240,
    standardName: 'Eastern Standard Time',
    standardOffset: -300,
  },
  {
    codes: 'CDT_CST',
    daylightName: 'Central Daylight Time',
    daylightOffset: -300,
    standardName: 'Central Standard Time',
    standardOffset: -340,
  },
  {
    codes: 'MDT_MST',
    daylightName: 'Mountain Daylight Time',
    daylightOffset: -360,
    standardName: 'Mountain Standard Time',
    standardOffset: -420,
  },
  {
    codes: 'PDT_PST',
    daylightName: 'Pacific Daylight Time',
    daylightOffset: -420,
    standardName: 'Pacific Standard Time',
    standardOffset: -480,
  },
  {
    codes: 'AKDT_AKST',
    daylightName: 'Alaska Daylight Time',
    daylightOffset: -480,
    standardName: 'Alaska Standard Time',
    standardOffset: -540,
  },
  {
    codes: 'HST',
    standardName: 'Hawaii-Aleutian Standard Time',
    standardOffset: -600,
  },
];

export const STATE_GRID_CONNECTIONS = {
  states: [
    {
      state: ["Arizona", "AZ"],
      new_system: { name: "Net Billing (Net Feed-in tariff)", type: "netFit" },
      system_expansion: { name: "Net Billing (Net Feed-in tariff)", type: "netFit" }
    },
    {
      state: ["Arkansas", "AR"],
      new_system: { name: "Net Billing (Net Feed-in tariff)", type: "netFit" },
      system_expansion: { name: "Net Billing (Net Feed-in tariff)", type: "netFit" }
    },
    {
      state: ["California", "CA"],
      new_system: { name: "Net Metering 3.0", type: "nem3" },
      system_expansion: { name: "Net Metering - Muti Tariff (expansion system)", type: "net" }
    },
    {
      state: ["Colorado", "CO"],
      new_system: { name: "Net Metering", type: "net" },
      system_expansion: { name: "Net Metering", type: "net" }
    },
    {
      state: ["Connecticut", "CT"],
      new_system: { name: "Net Metering", type: "net" },
      system_expansion: { name: "Net Metering", type: "net" }
    },
    {
      state: ["Delaware", "DE"],
      new_system: { name: "Net Metering", type: "net" },
      system_expansion: { name: "Net Metering", type: "net" }
    },
    {
      state: ["Florida", "FL"],
      new_system: { name: "Net Metering", type: "net" },
      system_expansion: { name: "Net Metering", type: "net" }
    },
    {
      state: ["Georgia", "GA"],
      new_system: { name: "Net Billing (Net Feed-in tariff)", type: "netFit" },
      system_expansion: { name: "Net Billing (Net Feed-in tariff)", type: "netFit" }
    },
    {
      state: ["Idaho", "ID"],
      new_system: { name: "Net Billing (Net Feed-in tariff)", type: "netFit" },
      system_expansion: { name: "Net Billing (Net Feed-in tariff)", type: "netFit" }
    },
    {
      state: ["Illinois", "IL"],
      new_system: { name: "Net Metering (Retail rate with fixed reduction)", type: "netFixedReduction" },
      system_expansion: { name: "Net Metering (Retail rate with fixed reduction)", type: "netFixedReduction" }
    },
    {
      state: ["Indiana", "IN"],
      new_system: { name: "Net Metering (Retail rate with fixed reduction)", type: "netFixedReduction" },
      system_expansion: { name: "Net Metering (Retail rate with fixed reduction)", type: "netFixedReduction" }
    },
    {
      state: ["Iowa", "IA"],
      new_system: { name: "Net Metering", type: "net" },
      system_expansion: { name: "Net Metering", type: "net" }
    },
    {
      state: ["Kansas", "KS"],
      new_system: { name: "Net Metering", type: "net" },
      system_expansion: { name: "Net Metering", type: "net" }
    },
    {
      state: ["Kentucky", "KY"],
      new_system: { name: "Net Metering", type: "net" },
      system_expansion: { name: "Net Metering", type: "net" }
    },
    {
      state: ["Louisiana", "LA"],
      new_system: { name: "Net Billing (Net Feed-in tariff)", type: "netFit" },
      system_expansion: { name: "Net Billing (Net Feed-in tariff)", type: "netFit" }
    },
    {
      state: ["Maine", "ME"],
      new_system: { name: "Net Metering", type: "net" },
      system_expansion: { name: "Net Metering", type: "net" }
    },
    {
      state: ["Maryland", "MD"],
      new_system: { name: "Net Metering", type: "net" },
      system_expansion: { name: "Net Metering", type: "net" }
    },
    {
      state: ["Massachusetts", "MA"],
      new_system: { name: "Net Metering", type: "net" },
      system_expansion: { name: "Net Metering", type: "net" }
    },
    {
      state: ["Michigan", "MI"],
      new_system: { name: "Net Billing (Net Feed-in tariff)", type: "netFit" },
      system_expansion: { name: "Net Billing (Net Feed-in tariff)", type: "netFit" }
    },
    {
      state: ["Minnesota", "MN"],
      new_system: { name: "Net Metering", type: "net" },
      system_expansion: { name: "Net Metering", type: "net" }
    },
    {
      state: ["Missouri", "MO"],
      new_system: { name: "Net Metering", type: "net" },
      system_expansion: { name: "Net Metering", type: "net" }
    },
    {
      state: ["Nevada", "NV"],
      new_system: { name: "Net Metering", type: "net" },
      system_expansion: { name: "Net Metering", type: "net" }
    },
    {
      state: ["New Hampshire", "NH"],
      new_system: { name: "Net Metering", type: "net" },
      system_expansion: { name: "Net Metering", type: "net" }
    },
    {
      state: ["New Jersey", "NJ"],
      new_system: { name: "Net Metering", type: "net" },
      system_expansion: { name: "Net Metering", type: "net" }
    },
    {
      state: ["New Mexico", "NM"],
      new_system: { name: "Net Metering", type: "net" },
      system_expansion: { name: "Net Metering", type: "net" }
    },
    {
      state: ["New York", "NY"],
      new_system: { name: "Net Metering", type: "net" },
      system_expansion: { name: "Net Metering", type: "net" }
    },
    {
      state: ["North Carolina", "NC"],
      new_system: { name: "Net Metering", type: "net" },
      system_expansion: { name: "Net Metering", type: "net" }
    },
    {
      state: ["Ohio", "OH"],
      new_system: { name: "Net Metering", type: "net" },
      system_expansion: { name: "Net Metering", type: "net" }
    },
    {
      state: ["Oklahoma", "OK"],
      new_system: { name: "Net Metering", type: "net" },
      system_expansion: { name: "Net Metering", type: "net" }
    },
    {
      state: ["Oregon", "OR"],
      new_system: { name: "Net Metering", type: "net" },
      system_expansion: { name: "Net Metering", type: "net" }
    },
    {
      state: ["Pennsylvania", "PA"],
      new_system: { name: "Net Metering", type: "net" },
      system_expansion: { name: "Net Metering", type: "net" }
    },
    {
      state: ["Rhode Island", "RI"],
      new_system: { name: "Net Metering", type: "net" },
      system_expansion: { name: "Net Metering", type: "net" }
    },
    {
      state: ["South Carolina", "SC"],
      new_system: { name: "Net Metering", type: "net" },
      system_expansion: { name: "Net Metering", type: "net" }
    },
    {
      state: ["Tennessee", "TN"],
      new_system: { name: "Net Metering", type: "net" },
      system_expansion: { name: "Net Metering", type: "net" }
    },
    {
      state: ["Texas", "TX"],
      new_system: { name: "Net Billing (Net Feed-in tariff)", type: "netFit" },
      system_expansion: { name: "Net Billing (Net Feed-in tariff)", type: "netFit" }
    },
    {
      state: ["Utah", "UT"],
      new_system: { name: "Net Billing (Net Feed-in tariff)", type: "netFit" },
      system_expansion: { name: "Net Billing (Net Feed-in tariff)", type: "netFit" }
    },
    {
      state: ["Vermont", "VT"],
      new_system: { name: "Net Metering", type: "net" },
      system_expansion: { name: "Net Metering", type: "net" }
    },
    {
      state: ["Virginia", "VA"],
      new_system: { name: "Net Metering", type: "net" },
      system_expansion: { name: "Net Metering", type: "net" }
    },
    {
      state: ["Washington", "WA"],
      new_system: { name: "Net Metering", type: "net" },
      system_expansion: { name: "Net Metering", type: "net" }
    },
    {
      state: ["Washington D.C.", "DC"],
      new_system: { name: "Net Metering", type: "net" },
      system_expansion: { name: "Net Metering", type: "net" }
    },
    {
      state: ["West Virginia", "WV"],
      new_system: { name: "Net Metering", type: "net" },
      system_expansion: { name: "Net Metering", type: "net" }
    },
    {
      state: ["Wisconsin", "WI"],
      new_system: { name: "Net Metering", type: "net" },
      system_expansion: { name: "Net Metering", type: "net" }
    }
  ],
  default_for_other_regions: "net"
};

export const timeCategories = [
  '12am',
  '1am',
  '2am',
  '3am',
  '4am',
  '5am',
  '6am',
  '7am',
  '8am',
  '9am',
  '10am',
  '11am',
  '12pm',
  '1pm',
  '2pm',
  '3pm',
  '4pm',
  '5pm',
  '6pm',
  '7pm',
  '8pm',
  '9pm',
  '10pm',
  '11pm',
];

export const weekendWeekdayDefaultObject = {
  morning: { start: 5, end: 9, usage: 0.19 },
  midday: { start: 9, end: 13, usage: 0.16 },
  afternoon: { start: 13, end: 17, usage: 0.19 },
  evening: { start: 17, end: 22, usage: 0.31 },
  night: { start: 22, end: 5, usage: 0.14 },
};